import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const formatConsultDateTime = (dateValue) => {
  if (!dateValue) return "YYYY-MM-DD";

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return dateValue;

  const parts = new Intl.DateTimeFormat('ko-KR', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});

  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
};

const CONSULT_MEMO_MAX_LENGTH = 1000;
const DEFAULT_CONSULT_STATUS = "CON_ST01";

const normalizeConsultStatus = (status) => {
  const nextStatus = String(status || "").trim();
  return nextStatus && nextStatus !== "전체" ? nextStatus : DEFAULT_CONSULT_STATUS;
};

const ConsultWrite = () => {
  console.log('ConsultWrite')
  const navigate = useNavigate();
  const { consu_seq } = useParams();
  console.log(consu_seq)
  const [inquiryDate, setInquiryDate] = useState("");
  const [consuStatList, setConsuStatList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(DEFAULT_CONSULT_STATUS);

  const [name, setName] = useState("");
  const [corp, setCorp] = useState("");
  const [tel, setTel] = useState("");
  const [memo, setMemo] = useState("");



  const getConsuStat = () => {
    let params = {};

    const successHandler = (response) => {
      if (response.messageCode === 200) {
        setConsuStatList(response.data.data_list);
      } else {
        console.log("상담 상태정보를 불러올 수 없습니다.");
        toast.error("상담 상태정보를 불러올 수 없습니다.");
      }
    };
    const failHandler = (error) => {
      console.log(error);
    };

    request.get("/common/code/consu_stat", params, successHandler, failHandler);
  };

  useEffect(() => {
    if (consu_seq) {
      const fetchInquiryData = async () => {
        try {
          const successHandler = (response) => {
            const data = response.data;
            setInquiryDate(data.reg_dtm);
            setSelectedStatus(normalizeConsultStatus(data.consu_stat))
            setName(data.consu_name || "");
            setCorp(data.consu_corp || "");
            setTel(data.consu_tel || "");
            setMemo(data.manger_memo || "");
          };

          const errorHandler = (error) => {
            toast.error("문의 불러오기 중 오류가 발생했습니다.");
          };

          await request.get(`/board/list/admin/consult/${consu_seq}`, {}, successHandler, errorHandler);
        } catch (error) {
          toast.error("문의 불러오기 중 오류가 발생했습니다.");
        }
      };

      fetchInquiryData();
      getConsuStat();
    }
  }, [consu_seq]);

  const handleMemoChange = (e) => {
    setMemo(e.target.value.slice(0, CONSULT_MEMO_MAX_LENGTH));
  };



  const handleSubmit = async () => {
    const nextStatus = String(selectedStatus || '').trim();
    const nextMemo = String(memo || '').trim();

    const formData = {
      consu_stat: normalizeConsultStatus(nextStatus),
      manger_memo: nextMemo
    };

    try {
      const successHandler = (response) => {
        console.log('메모 답변등록 response', response)
        if (response.messageCode === 200) {
          toast.success(`상담 신청 관리 내용이 성공적으로 ${consu_seq ? "수정" : "등록"}되었습니다.`);
          navigate("/Manage/Consult");
        } else if (response.messageCode === 411) {
          toast.error(`변경된 상담 신청 관리 내용이 없습니다.`);
        } else {
          toast.error(`상담 신청 관리 내용 ${consu_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
        }
      };

      const errorHandler = (error) => {
        toast.error(`문의 ${consu_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
      };

      if (consu_seq) {
        await request.put(`/board/consult/${consu_seq}`, formData, successHandler, errorHandler);
      } else {
        await request.post("/board/consult", formData, successHandler, errorHandler);
      }

    } catch (error) {
      toast.error(`문의 ${consu_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
    }
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">상담 신청 {consu_seq ? "관리" : "등록"}</h2>
      <div className="adm_com_pg_content">
        <table className='adm_com_board_list type_row'>
          <colgroup>
            <col width="10%" /><col />
            <col width="10%" /><col />
          </colgroup>
          <tbody>
            <tr>
              <th>등록일</th>
              <td colSpan={3}>{formatConsultDateTime(inquiryDate)}</td>
            </tr>
            <tr>
              <th>처리상태</th>
              <td colSpan={3}>
                <select className="select" value={selectedStatus} onChange={handleStatusChange}>
                  {consuStatList.map((title) => (
                    <option key={title.comm_code} value={title.comm_code}>
                      {title.code_nm}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>이름/직책</th>
              <td>
                {name}
              </td>
              <th>회사명</th>
              <td>
                {corp}
              </td>
            </tr>
            <tr>
              <th>전화번호</th>
              <td colSpan={3}>{tel}</td>
            </tr>
            <tr>
              <th>상담자</th>
              <td colSpan={3}>관리자</td>
            </tr>
            <tr>
              <th>메모</th>
              <td colSpan={3}>
                <textarea
                  className="textarea"
                  value={memo}
                  maxLength={CONSULT_MEMO_MAX_LENGTH}
                  onChange={handleMemoChange}
                ></textarea>
                <p className="info_txt">{memo.length.toLocaleString()} / {CONSULT_MEMO_MAX_LENGTH.toLocaleString()}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn blue" onClick={handleSubmit}>{consu_seq ? "수정" : "등록"}</button>
          <button className="adm_com_btn gray" onClick={() => navigate("/Manage/Consult")}>취소</button>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};

export default ConsultWrite;
